import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-team-goal-overview',
    templateUrl: './team-goal-overview.component.html',
    styleUrls: ['./team-goal-overview.component.css']
})
export class TeamGoalOverviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
